import React from "react"
import classNames from "utils/classNames"
import styles from "./style.module.css"
type DividerProps = React.ComponentProps<"hr"> & {
  dashed?: boolean
}
const Divider = ({ dashed, className, ...props }: DividerProps) => {
  return (
    <hr
      className={classNames(
        styles["base"],
        dashed && styles["dashed"],
        className
      )}
      {...props}
    />
  )
}

export default Divider
